// extracted by mini-css-extract-plugin
export default {"loaderContainer":"Loader_loaderContainer__gWDXA","loader":"Loader_loader__Iv4Mh","spin":"Loader_spin__I0Tfd"};